import { Checkbox, LabelProps, Snackbar } from "@mcleod/components";
import { PortalCustomerSettings } from "@mcleod/portal-customer";
import { AutogenLayoutOrderTermsConditions } from "./autogen/AutogenLayoutOrderTermsConditions";

export class OrderTermsConditions extends AutogenLayoutOrderTermsConditions {

    override onLoad() {
        this.textboxTerms.text = PortalCustomerSettings.get().order_terms_conditions;
    }

    checkboxAgreeOnChange(event) {
        const checkbox = event.target as Checkbox;
        checkbox.color = event.newValue ? "success" : "error";
        checkbox.checkColor = checkbox.color;
    }

    userAgreed(): boolean {
        if (!this.checkboxAgree.checked) {
            const labelProps: Partial<LabelProps> = {
                padding: 0,
                width: 450,
                text: "Please accept Terms and Conditions before proceeding."
            };
            Snackbar.showWarningSnackbar(labelProps, { id: "terms", persist: true });
            return false;
        }
        return true;
    }

}
